import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router";

export const BrandText = observer(function BrandText({
  disableFullText,
  sx,
  ...props
}) {
  const navigate = useNavigate();
  return (
    <Box onClick={() => navigate("/")}>
      <Typography
        textAlign="center"
        {...props}
        sx={(theme) => ({
          fontFamily: "PermanentMarker",
          fontSize: 28,
          lineHeight: "36px",
          WebkitTextStroke: 1,
          WebkitTextStrokeColor: theme.palette.secondary.main,
          WebkitTapHighlightColor: "transparent",
          cursor: "pointer",
          color: "black",
          ...sx,
        })}
      >
        {disableFullText ? "L" : "NextYear"}
      </Typography>
    </Box>
  );
});

export default BrandText;
